import {
  createLoaderService,
  createSection2DocumentUploadStore,
  createSectionFlowRoutingService,
  createTrackingService,
} from '@services/factories';
import * as React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {ISection2DocumentUploadStore} from '@stores/onboarding-review/section2-document-upload-store';
import DocumentUploadProvider from '../../../providers/DocumentUploadProvider';
import {observer} from 'mobx-react';
import {merge, Subscription} from 'rxjs';
import {
  continueOnboardingReview,
  finishOnboardingReview,
  FlowAction,
  onboardingFlowActions,
} from '@flows/onboarding-review/navigation';
import I9ReceiptDocumentUploadPage from './receipt-document-upload-page';
import {toJS} from 'mobx';
import I9DocumentUploadPage from './document-upload-page';
import {ISectionFlowRoutingService} from '@services/section-flow-routing-service';
import {ITrackingService} from '@services/TrackingService';
import {ClientTrackingCategory} from '@models/client-tracking-category';
import {ClientTrackingName} from '@models/client-tracking-name';
import {RemoteI9StatusDetails} from '@dtos/remote-i9-status';
import {get} from 'lodash';
import {UploadDocumentRequest} from '@swipejobs/i9-document-validations-react';
import {DocumentUploadResponse} from '@models/onboarding-review/section2-document-upload';
import {IPersonPidEncryptionService} from '@services/onboarding-review/person-pid-encryption-service';

@observer
class I9DocumentUpload extends React.Component<RouteComponentProps> {
  store: ISection2DocumentUploadStore = createSection2DocumentUploadStore();
  private onboardingFlowRouteSubscription: Subscription = Subscription.EMPTY;
  sectionFlowRoutingService: ISectionFlowRoutingService =
    createSectionFlowRoutingService();
  trackingService: ITrackingService = createTrackingService();

  loaderService = createLoaderService();

  async componentDidMount() {
    await this.store.initialise();

    this.onboardingFlowRouteSubscription = merge(
      continueOnboardingReview,
      finishOnboardingReview
    ).subscribe(
      (route) => this.props.history.push(route),
      (error) => console.error(error)
    );
  }

  componentWillUnmount() {
    this.onboardingFlowRouteSubscription.unsubscribe();
  }

  handleUpload = async (
      requestList: UploadDocumentRequest[],
      onDocumentUploaded?: (
          documentUploadResponse: DocumentUploadResponse[],
          personPidEncryptionService: IPersonPidEncryptionService
      ) => Promise<void>
  ) => {
    createLoaderService().showLoader();
    await this.store.uploadDocumentsAsync(requestList, onDocumentUploaded);
    createLoaderService().hideLoader();

    if (this.store.confirmationRequestStatus !== 'success') {
      return;
    }

    onboardingFlowActions.next(FlowAction.DocumentUploaded);
  };

  handleUseOtherDocuments = async () => {
    try {
      this.loaderService.showLoader();
      await this.store.handleArchiveReceipts();
      const routeToStart =
        await this.sectionFlowRoutingService.routeSectionFromStatusAsync();
      this.props.history.push(routeToStart);
      this.trackingService.trackEvent(
        ClientTrackingCategory.Section2UploadOtherDocuments,
        ClientTrackingName.Success
      );
    } catch (err) {
      console.error(err);
      this.trackingService.trackEvent(
        ClientTrackingCategory.Section2UploadOtherDocuments,
        ClientTrackingName.Error
      );
    } finally {
      this.loaderService.hideLoader();
    }
  };

  render() {
    const i9StatusDetailsObj: RemoteI9StatusDetails | {} = {
      ...this.store.i9StatusDetails,
    };

    const receiptReplacementDocumentRequired = get(
      i9StatusDetailsObj,
      'receiptReplacementDocumentRequired'
    );
    const isReceiptUpload = receiptReplacementDocumentRequired;
    return (
      <DocumentUploadProvider workStatus={this.store.workStatus}>
          <I9DocumentUploadPage
            store={this.store}
            onConfirm={this.handleUpload}
            isReceiptUpload={isReceiptUpload}
            onUseOtherDocuments={this.handleUseOtherDocuments}
          />
      </DocumentUploadProvider>
    );
  }
}

export default I9DocumentUpload;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/index.tsx